module.exports = __webpack_public_path__ + "img/trainer-list-banner.7e6e44ab.jpg";